import React from 'react';

const Telly = require('../../images/telly-walk.webm');

export default function WaitingIndicatorTelly() {
	return (
		<div className="waiting-indicator-telly">
			<video
				className="telly"
				src={Telly}
				autoPlay={true}
				loop={true}
				muted={true}
			/>
		</div>
	);
}
